import { formatSymbol } from "@/utils/i18n/format-symbol";

export const financialReports = {
  zh: {
    financialReportTitle: (symbol: string) =>
      `${formatSymbol(symbol)} 財報數據`,
    financial: `財務`,
    valuation: `估值`,
    growth: `成長能力`,
    profitability: `獲利能力`,
  },
  en: {
    financialReportTitle: (symbol: string) =>
      `${formatSymbol(symbol)} Financials`,
    financial: `Financial`,
    valuation: `Valuation`,
    growth: `Growth`,
    profitability: `Profitability`,
  },
};
